export default __webpack_public_path__ + "static/media/04-DJ_1.99cd297a.gif";